import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KycCameraRoutingModule } from './kyc-camera-routing.module';
import { KycCameraComponent } from './kyc-camera.component';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/core/material';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NzIconModule, NzStepsModule, NzTableModule, NzTabsModule, NzUploadModule} from 'ng-zorro-antd';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {WebcamModule} from 'ngx-webcam';


@NgModule({
  declarations: [KycCameraComponent],
  imports: [
      CommonModule,
      KycCameraRoutingModule,
      TranslateModule,
      MaterialModule,
      SharedModule,
      FormsModule,
      ReactiveFormsModule,
      NzStepsModule,
      NzTableModule,
      NzTabsModule,
      NzUploadModule,
      NgxExtendedPdfViewerModule,
      NzIconModule,
      WebcamModule
  ],
  entryComponents: [],
})
export class KycCameraModule { }
